<template>
  <v-dialog v-model="openDialogue" persistent max-width="450">
    <v-card tile>
      <vue-card-title
        :title="cardHeaderInfo"
        :subtitle="' '"
        :icon="$getIcon('mdiFileDocumentEdit')"
        closable
        @close="$emit('update:open-dialogue', false)"
      >
      </vue-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-3">
        {{ cardTextInfo }}
      </v-card-text>
      <v-divider light> </v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="red darken-1"
          text
          @click="$emit('update:open-dialogue', false)"
        >
          No
        </v-btn>
        <v-btn color="green darken-1" text @click="$emit('confirm-delete')">
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    openDialogue: {
      type: Boolean,
      required: false
    },
    cardHeaderInfo: {
      type: String,
      required: false,
      default: ""
    },
    cardTextInfo: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      dialogueOpen: false
    };
  }
};
</script>

<style scoped></style>
